/**
 * Refresh all carousels inside container
 * @param {HTMLElement} container Node to find carousels inside
 * @returns {HTMLElement}
 */
import Media from "../components/Media.js";
import Related from "../components/Related.js";
function refreshCarousels(container) {
    const carousels = container.querySelectorAll("[data-carousel]");

    carousels.forEach((element) => {
        const id = element.getAttribute("data-carousel");

        // If carousel already has slick defined refresh it else set up new slick instance
        if (element.carousel) {
            element.carousel.slick("refresh");
        } else {
            if (id.includes("media")) new Media(element);
            if (id.includes("related")) new Related(element);
        }
    });
}

/**
 * Refresh all dialogs inside container
 * @param {HTMLElement} container Node to find dialog buttons inside
 * @returns {HTMLElement}
 */
import Dialog from "./Dialog.js";
function refreshDialogs(container) {
    const dialogElements = container.querySelectorAll("[data-dialog]");
    dialogElements.forEach((button) => {
        new Dialog(button);
    });
}

/**
 * Refresh all accordions inside container
 * @param {HTMLElement} container Node to find dialog buttons inside
 * @returns {HTMLElement}
 */
import Accordion from "../components/Accordion.js";
function refreshAccordions(container) {
    const accordionElements = container.querySelectorAll(
        ".accordion-content-outer",
    );
    accordionElements.forEach((element) => {
        new Accordion(element);
    });
}


/**
 * Refresh all disclosures inside container
 * @param {HTMLElement} container Node to find dialog buttons inside
 * @returns {HTMLElement}
 */
import Disclosure from "../utils/Disclosure.js";
function refreshDisclosures(container) {
    const elements = container.querySelectorAll("[data-disclosure]");
    let disclosures = [];

    elements.forEach((element) => {
        let disclosure = new Disclosure(element);
        disclosures.push(disclosure);
    });

    return disclosures;
}

export default {
    refreshCarousels,
    refreshDialogs,
    refreshAccordions,
    refreshDisclosures,
};
